/** AUTO GENERATED FROM "node ./src/utils/convert-icons.js". DO NOT TOUCH. **/
import React from 'react'
import classNames from 'classnames'


class Icon extends React.PureComponent {
  render () {
    const { className, svgRef, ...otherProps } = this.props
    return (
      <svg width="14" height="8" viewBox="0 0 14 8" fill="currentColor" className={classNames('nmx-icon', className)} ref={svgRef} {...otherProps}>
  
  <polygon points="12.632 7.978 7.034 2.606 1.36 8 0 6.693 7.042 0 14 6.679" className="icon-fill"/>
</svg>

    )
  }
}

Icon.displayName = 'DrawerCaretFlippedIcon'

export default Icon
